import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TwoFactorService {
  openTwoFactorPopup() {
    const popup = document.getElementById('twoFactorPopup');
    if (popup) {
      popup.style.display = 'block';
    }
  }

  closeTwoFactorPopup() {
    const popup = document.getElementById('twoFactorPopup');
    if (popup) {
      popup.style.display = 'none';
    }
  }
}
